export default function buildPostListing({
    apiEndpoint,
    apiTools
}) {
    return async function postListing(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }`
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'multipart/form-data',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}